import React from 'react';
import { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Experience from './components/Experience';
import Technologies from './components/Technologies';
import CTA from './components/CTA';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import MobileAppsPage from './components/MobileAppsPage';
import DesktopSoftwarePage from './components/DesktopSoftwarePage';
import N8NAutomationPage from './components/N8NAutomationPage';
import WebAppsPage from './components/WebAppsPage';
import AIPage from './components/AIPage';
import useVisitorTracking from './hooks/useVisitorTracking';

function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'mobile-apps' | 'desktop-software' | 'n8n-automation' | 'web-apps' | 'ai'>('home');
  
  // Track visitor when app loads
  useVisitorTracking();

  if (currentPage === 'mobile-apps') {
    return <MobileAppsPage onBack={() => setCurrentPage('home')} />;
  }

  if (currentPage === 'desktop-software') {
    return <DesktopSoftwarePage onBack={() => setCurrentPage('home')} />;
  }

  if (currentPage === 'n8n-automation') {
    return <N8NAutomationPage onBack={() => setCurrentPage('home')} />;
  }

  if (currentPage === 'web-apps') {
    return <WebAppsPage onBack={() => setCurrentPage('home')} />;
  }

  if (currentPage === 'ai') {
    return <AIPage onBack={() => setCurrentPage('home')} />;
  }

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <About />
      <Services 
        onNavigateToMobileApps={() => setCurrentPage('mobile-apps')}
        onNavigateToDesktopSoftware={() => setCurrentPage('desktop-software')}
        onNavigateToN8NAutomation={() => setCurrentPage('n8n-automation')}
        onNavigateToWebApps={() => setCurrentPage('web-apps')}
        onNavigateToAI={() => setCurrentPage('ai')}
      />
      <Experience />
      <Technologies />
      <CTA />
      <Contact />
      <Footer />
      <WhatsAppButton />
    </div>
  );
}

export default App;